import React, { Component } from "react";

import {
  checkValidity,
  doLog,
  getNumber,
  hasValue,
  // LogDebug,
  lookupLabelFromList,
  notNull,
  updateObject,
} from "../../../shared/utility";
import formClasses from "./Form.css";
import FormField from "../FormField/FormField";
import moment from "moment";

class Form extends Component {
  checkFieldForChange(fieldName, select) {
    let result = false;
    let fieldValue = this.state[fieldName];
    if (fieldValue === null) fieldValue = "";
    if (select) {
      result =
        notNull(fieldValue) !== notNull(this.getMappedPropValue(fieldName));
    } else {
      result =
        notNull(fieldValue.value) !==
        notNull(this.getMappedPropValue(fieldName));
    }

    return result;
  }

  checkArrayFieldForRequired(array, fieldName, select) {
    if (doLog()) console.log("[Form].checkArrayFieldForRequired array:", array);
    let result = false;
    if (array !== null) {
      if (doLog())
        console.log(
          "[Form].checkArrayFieldForRequired fieldName:" +
            fieldName +
            " field:",
          array[fieldName]
        );
      if (
        hasValue(array[fieldName]) &&
        array[fieldName].validation &&
        array[fieldName].validation.required
      ) {
        let fieldValue = array[fieldName];
        result = notNull(fieldValue.value) === "";
        if (result) {
          if (doLog())
            console.log(
              "[Form].checkArrayFieldForRequired field required and value missing:" +
                fieldName
            );
        }
      }
    }
    return result;
  }

  checkFieldForRequired(fieldName, select) {
    let result = false;
    if (
      hasValue(this.state[fieldName]) &&
      this.state[fieldName].validation &&
      this.state[fieldName].validation.required === true
    ) {
      let fieldValue = this.state[fieldName];
      result =
        notNull(fieldValue.value) === "" || fieldValue.value === "Invalid date";
    }
    return result;
  }

  checkForChangesMade() {
    // if (doLog()) console.log("[Form][checkForChangesMade] state:", this.state);
    let changed = false;
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      // if (doLog()) console.log("[Form][checkForChangesMade] field:",  fieldName);
      if (this.checkFieldForChange(fieldName, false)) {
        changed = true;
        break;
      }
    }

    if (!changed) {
      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        if (doLog())
          console.log("[Form][checkForChangesMade] field:", fieldName);
        if (this.checkFieldForChange(fieldName, true)) {
          changed = true;
          break;
        }
      }
    }

    // if (doLog()) console.log("[Form][checkForChangesMade] changed:", changed);
    return changed;
  }

  checkRequiredField() {
    let needed = false;

    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      // if (doLog()) console.log("[Form][checkRequiredField] text field:",  fieldName);
      if (this.checkFieldForRequired(fieldName, false)) {
        if (doLog())
          console.log(
            "[Form][checkRequiredField] text field needed:" +
              fieldName +
              " section:" +
              this.state.sectionName
          );
        needed = true;
        break;
      }
    }

    if (!needed) {
      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        // if (doLog())  console.log("[Form][checkRequiredField] select field:",  fieldName);
        if (this.checkFieldForRequired(fieldName, true)) {
          if (doLog())
            console.log(
              "[Form][checkRequiredField] select field needed:",
              fieldName
            );
          needed = true;
          break;
        }
      }
    }

    const checkPerson =
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIRENAMEINFO === "Y";
    const checkProperty =
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREPROPERTYINFO === "Y";
    const checkVehicle =
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREVEHICLEINFO === "Y";

    // if (!needed && checkProperty && this.state.sectionName === "Property") {
    if (!needed && checkProperty) {
      if (doLog())
        console.log("[Form][checkRequiredField] checkProperty:", checkProperty);
      needed = this.checkRequiredPropertyArray();
    }
    // if (!needed && checkVehicle && this.state.sectionName === "Vehicle") {
    if (!needed && checkVehicle) {
      if (doLog())
        console.log("[Form][checkRequiredField] checkVehicle:", checkVehicle);
      needed = this.checkRequiredVehicleArray();
    }
    // if (!needed && checkPerson && this.state.sectionName === "Person") {
    if (!needed && checkPerson) {
      if (doLog())
        console.log("[Form][checkRequiredField] checkPerson:", checkPerson);
      needed = this.checkRequiredPersonArray();
    }
    // if (!needed && this.state.sectionName === "Attachment") {
    if (!needed) {
      if (doLog()) console.log("[Form][checkRequiredField] checkAttachment");
      needed = this.checkRequiredAttachmentArray();
    }
    // if (doLog()) console.log("[Form][checkRequiredField] needed:", needed);
    return needed;
  }

  checkRequiredAttachmentArray() {
    let needed = false;

    if (doLog())
      console.log(
        "[Form][checkRequiredAttachmentArray] attachmentArray:",
        this.props.attachmentArray
      );
    if (
      this.props.attachmentArray &&
      this.props.attachmentArray !== null &&
      this.props.attachmentArray.length > 0
    ) {
      for (let i = 0; i < this.props.attachmentArray.length; i++) {
        const array = this.props.attachmentArray[i].attachmentFields;

        // if (array === null) {
        //   if (doLog()) console.log("[Form][checkRequiredAttachmentArray] needed because attachmentFields is null");
        //   needed = true;
        // } else {
        for (let field in this.props.attachmentTextFieldList) {
          const fieldName = this.props.attachmentTextFieldList[field];
          if (doLog())
            console.log(
              "[Form][checkRequiredAttachmentArray] text field:",
              fieldName
            );
          if (this.checkArrayFieldForRequired(array, fieldName, false)) {
            if (doLog())
              console.log(
                "[Form][checkRequiredAttachmentArray] field needed:",
                fieldName
              );
            needed = true;
            break;
          }
        }

        if (!needed) {
          for (let field in this.props.attachmentSelectFieldList) {
            const fieldName = this.props.attachmentSelectFieldList[field];
            if (doLog())
              console.log(
                "[Form][checkRequiredAttachmentArray] select field:",
                fieldName
              );
            if (this.checkArrayFieldForRequired(array, fieldName, true)) {
              if (doLog())
                console.log(
                  "[Form][checkRequiredAttachmentArray] field needed:",
                  fieldName
                );
              needed = true;
              break;
            }
          }
        }
        // }
      }
    }

    return needed;
  }

  checkRequiredPersonArray() {
    let needed = false;

    if (doLog())
      console.log(
        "[Form][checkRequiredPersonArray] personArray:",
        this.props.personArray
      );
    if (
      this.props.personArray &&
      this.props.personArray !== null &&
      this.props.personArray.length > 0
    ) {
      for (let i = 0; i < this.props.personArray.length; i++) {
        const array = this.props.personArray[i].personFields;

        if (array === null) {
          if (doLog())
            console.log(
              "[Form][checkRequiredPersonArray] field needed: personFields is null"
            );
          needed = true;
        } else {
          if (array.deleted.value !== "Y") {
            for (let field in this.props.personTextFieldList) {
              const fieldName = this.props.personTextFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredPersonArray] text field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, false)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredPersonArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }

          if (!needed) {
            for (let field in this.props.personSelectFieldList) {
              const fieldName = this.props.personSelectFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredPersonArray] select field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, true)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredPersonArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }
        }
      }
    }

    return needed;
  }

  checkRequiredPropertyArray() {
    let needed = false;

    if (doLog())
      console.log(
        "[Form][checkRequiredPropertyArray] propertyArray:",
        this.props.propertyArray
      );
    if (
      this.props.propertyArray &&
      this.props.propertyArray !== null &&
      this.props.propertyArray.length > 0
    ) {
      for (let i = 0; i < this.props.propertyArray.length; i++) {
        const array = this.props.propertyArray[i].propertyFields;

        if (array === null) {
          if (doLog())
            console.log(
              "[Form][checkRequiredPropertyArray] field needed: propertyFields is null"
            );
          needed = true;
        } else {
          if (array.deleted.value !== "Y") {
            for (let field in this.props.propertyTextFieldList) {
              const fieldName = this.props.propertyTextFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredPropertyArray] text field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, false)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredPropertyArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }

          if (!needed) {
            for (let field in this.props.propertySelectFieldList) {
              const fieldName = this.props.propertySelectFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredPropertyArray] select field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, true)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredPropertyArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }
        }
      }
    }

    return needed;
  }

  checkRequiredVehicleArray() {
    let needed = false;

    if (doLog())
      console.log(
        "[Form][checkRequiredVehicleArray] vehicleArray:",
        this.props.vehicleArray
      );
    if (
      this.props.vehicleArray &&
      this.props.vehicleArray !== null &&
      this.props.vehicleArray.length > 0
    ) {
      for (let i = 0; i < this.props.vehicleArray.length; i++) {
        const array = this.props.vehicleArray[i].vehicleFields;

        if (array === null) {
          if (doLog())
            console.log(
              "[Form][checkRequiredVehicleArray] field needed: vehicleFields is null"
            );
          needed = true;
        } else {
          if (array.deleted.value !== "Y") {
            for (let field in this.props.vehicleTextFieldList) {
              const fieldName = this.props.vehicleTextFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredVehicleArray] text field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, false)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredVehicleArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }

          if (!needed) {
            for (let field in this.props.vehicleSelectFieldList) {
              const fieldName = this.props.vehicleSelectFieldList[field];
              // if (doLog()) console.log("[Form][checkRequiredVehicleArray] select field:",  fieldName);
              if (this.checkArrayFieldForRequired(array, fieldName, true)) {
                if (doLog())
                  console.log(
                    "[Form][checkRequiredVehicleArray] field needed:",
                    fieldName
                  );
                needed = true;
                break;
              }
            }
          }
        }
      }
    }

    return needed;
  }

  escapeRegExp = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  fieldTag(fieldName) {
    return (
      "<" +
      fieldName +
      ">" +
      this.state[fieldName].value +
      "</" +
      fieldName +
      ">"
    );
  }

  fieldTagValue(fieldName, value) {
    return "<" + fieldName + ">" + value + "</" + fieldName + ">";
  }

  getCustomText(textLocation) {
    let text = "";
    if (hasValue(this.props.customTextList)) {
      const selectedRow = this.props.customTextList.find(
        (option) => option.data.TEXTLOCATION === textLocation
      );
      text = selectedRow.data.CUSTOMTEXT;
    }
    if (doLog())
      console.log("[Form][getCustomText] textLocation:", textLocation);
    if (doLog()) console.log("[Form][getCustomText] text:", text);
    return text;
  }

  getKeyFieldName() {
    let keyFieldName = null;
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      // if (doLog()) console.log("[Form][getKeyField] field:",  field);
      if (doLog()) console.log("[Form][getKeyFieldName] fieldName:", fieldName);
      // if (doLog()) console.log("[Form][getKeyField] object:",  this.state[fieldName]);
      if (this.state[fieldName].keyField) {
        keyFieldName = fieldName;
      }
    }
    if (doLog())
      console.log("[Form][getKeyFieldName] keyFieldName:", keyFieldName);
    return keyFieldName;
  }

  getFormField = (fieldName, useFullWidth, showLabel) => {
    if (doLog()) console.log("[Form][getFormField] fieldName:", fieldName);
    let editMode = false;
    let inputType = null;
    let optionList = [];
    let fieldValue = null;
    let fieldLabel = null;
    let selectValueFieldName = null;
    let selectListName = null;
    let changeFunction = null;
    let clickFunction = null;
    // let keyPressFunction = null;
    let checkedValue = null;
    let uncheckedValue = null;
    let choices = null;
    let fullWidth = false;
    let invalid = false;
    let invalidMsg = "";
    let skip = false;
    let required = false;
    let placeHolder = null;
    let multiline = null;
    let rows = 1;
    //
    let rowCount = 1;
    let defaultGridRows = [];
    let gridRows = [];
    let gridColumns = [];
    let gridSearchClickFunction = null;
    let gridRowClickFunction = null;
    let gridRowCheckBoxFunction = null;
    let searchText = null;
    let hideFooter = null;
    let selectedRows = [];
    //
    let disabled = false;
    let disablePast = false;
    let disableFuture = false;
    // let dateFormatter = null;

    if (this.state[fieldName]) {
      // keyPressFunction = this.handleKeyPress;

      const dependentOnFieldName = this.state[fieldName].dependentOn;
      if (
        !dependentOnFieldName ||
        dependentOnFieldName === null ||
        (this.state[dependentOnFieldName].value != null &&
          this.state[dependentOnFieldName].value.length > 0)
      ) {
        let enterAllowed = this.state[fieldName].enterOnAddOnly ? false : true;
        if ((this.state.editMode && enterAllowed) || this.state.addMode)
          editMode = true;
        if (useFullWidth) fullWidth = true;
        if (
          this.state[fieldName].validation &&
          this.state[fieldName].validation.required === true
        )
          required = true;
        inputType = this.state[fieldName].inputType;
        disablePast = this.state[fieldName].disablePast;
        disableFuture = this.state[fieldName].disableFuture;
        disabled = this.state[fieldName].disabled;
        const validityResult = checkValidity(
          this.state[fieldName].value,
          this.state[fieldName].validation
        );
        // if (doLog()) console.log("getFormField validityResult:", validityResult);
        if (!validityResult.isValid) {
          invalid = true;
          invalidMsg = validityResult.invalidMsg;
        }
        // if (doLog()) console.log("getFormField field object:", this.state[fieldName]);
        // if (doLog()) console.log('getFormField editMode:', editMode);
        // if (doLog()) console.log("getFormField inputType:", this.state[fieldName].inputType);
        // if (doLog()) console.log("getFormField label:", this.state[fieldName].label);
        // if (doLog()) console.log("getFormField value:", this.state[fieldName].value);
        // if (doLog()) console.log("getFormField rows:", this.state[fieldName].rows);

        //=======================================================================
        if (inputType === "checkbox") {
          fieldValue = this.state[fieldName].value;
          checkedValue = this.state[fieldName].checkedValue;
          uncheckedValue = this.state[fieldName].uncheckedValue;
          changeFunction = this.handleCheckBoxChange(fieldName);
          fieldLabel = this.state[fieldName].label;
          //=======================================================================
        } else if (inputType === "date") {
          fieldValue = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          // changeFunction = this.handleDateChange(fieldName);
          // changeFunction = this.handleDateStrChange(fieldName);
          changeFunction = this.handleTextChange(fieldName);
          //=======================================================================
        } else if (inputType === "datepicker") {
          fieldValue = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          changeFunction = this.handleDateChange(fieldName);
          //=======================================================================
        } else if (inputType === "datetime") {
          fieldValue = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          changeFunction = this.handleDateTimeChange(fieldName);
          //=======================================================================
        } else if (inputType === "radioGroup") {
          fieldValue = this.state[fieldName].value;
          choices = this.state[fieldName].choices;
          changeFunction = this.handleRadioGroupChange(fieldName);
          //=======================================================================
        } else if (inputType === "select") {
          if (doLog())
            console.log("[Form][getFormField] select fieldName:", fieldName);
          if (doLog()) console.log("[Form][getFormField] props:", this.props);
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          placeHolder = this.state[fieldName].placeHolder;
          selectListName = this.state[fieldName].listName;
          optionList = this.state[fieldName].optionList;
          const fieldList = this.props[selectListName];
          // if (doLog()) console.log("[Form][getFormField] select " + selectListName + " list:", fieldList);
          if (!hasValue(optionList) && fieldList !== null) {
            optionList = fieldList;
          }
          fieldValue = notNull(this.state[fieldName].value);
          // if (doLog()) console.log("[Form][getFormField] select " + selectListName + " fieldValue:", fieldValue);
          if (doLog())
            console.log(
              "[Form][getFormField] select onChange:",
              this.state[fieldName].onChange
            );
          if (hasValue(this.state[fieldName].onChange)) {
            changeFunction = this.state[fieldName].onChange;
          } else {
            changeFunction = this.handleSelectChange;
          }
          //=======================================================================
        } else if (inputType === "datagridsearch") {
          fieldValue = this.state[fieldName].value;
          searchText = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          const gridFieldName = this.state[fieldName].gridFieldName;
          changeFunction = this.handleGridSearchChange(
            fieldName,
            gridFieldName
          );
          if (hasValue(this.state[gridFieldName].onSearchClick)) {
            gridSearchClickFunction = this.state[gridFieldName].onSearchClick;
          } else {
            gridSearchClickFunction = this.handleGridSearchClick(
              fieldName,
              gridFieldName
            );
          }
        } else if (inputType === "datagrid") {
          if (doLog())
            console.log("[Form][getFormField] datagrid fieldName:", fieldName);
          if (doLog())
            console.log("[Form][getFormField] datagrid state:", this.state);
          fieldValue = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          rowCount = this.state[fieldName].rowCount;
          defaultGridRows = this.state[fieldName].defaultGridRows;
          gridRows = this.state[fieldName].gridRows;
          searchText = this.state[fieldName].searchText;
          gridColumns = this.state[fieldName].gridColumns;
          hideFooter = this.state[fieldName].hideFooter;
          selectedRows = this.state[fieldName].selectedRows;
          if (hasValue(this.state[fieldName].onChange)) {
            changeFunction = this.state[fieldName].onChange;
          } else {
            changeFunction = this.handleGridSearchChange(fieldName, fieldName);
          }
          if (hasValue(this.state[fieldName].onGridRowClick)) {
            gridRowClickFunction = this.state[fieldName].onGridRowClick(
              fieldName
            );
          } else {
            gridRowClickFunction = this.handleGridRowClick(fieldName);
          }

          if (hasValue(this.state[fieldName].onGridCheckBoxClick)) {
            gridRowCheckBoxFunction = this.state[fieldName].onGridCheckBoxClick(
              fieldName
            );
          } else {
            gridRowCheckBoxFunction = this.handleGridCheckBoxClick(fieldName);
          }
          //=======================================================================
        } else {
          fieldValue = this.state[fieldName].value;
          if (showLabel) {
            fieldLabel = this.state[fieldName].label;
          }
          multiline = this.state[fieldName].multiline;
          rows = this.state[fieldName].rows;
          changeFunction = this.handleTextChange(fieldName);
        }
      } else {
        skip = true;
      }
    }

    return (
      <FormField
        inputType={inputType}
        value={notNull(fieldValue)}
        label={fieldLabel}
        showLabel={showLabel}
        optionList={optionList}
        onChange={changeFunction}
        // onKeyPress={keyPressFunction}
        onClick={clickFunction}
        editMode={editMode}
        fieldName={fieldName}
        fieldValue={fieldValue}
        selectValueFieldName={selectValueFieldName}
        selectListName={selectListName}
        fullWidth={fullWidth}
        checkedValue={checkedValue}
        uncheckedValue={uncheckedValue}
        choices={choices}
        invalid={invalid}
        invalidMsg={invalidMsg}
        skip={skip}
        required={required}
        useDisabledForNonEdit={true}
        placeHolder={placeHolder}
        multiline={multiline}
        rows={rows}
        //
        rowCount={rowCount}
        defaultGridRows={defaultGridRows}
        gridRows={gridRows}
        gridColumns={gridColumns}
        searchText={searchText}
        hideFooter={hideFooter}
        gridSearchClickFunction={gridSearchClickFunction}
        gridRowClickFunction={gridRowClickFunction}
        gridRowCheckBoxFunction={gridRowCheckBoxFunction}
        selectedRows={selectedRows}
        //
        disabled={disabled}
        disablePast={disablePast}
        disableFuture={disableFuture}
        // dateFormatter={dateFormatter}
      />
    );
  };

  getFormFieldLabel(fieldName, isColumn) {
    let fieldLabel = null;
    if (this.state[fieldName]) {
      let editMode = false;
      let enterAllowed = this.state[fieldName].enterOnAddOnly ? false : true;
      if ((this.state.editMode && enterAllowed) || this.state.addMode)
        editMode = true;
      let labelStr = this.state[fieldName].label;
      if (labelStr) {
        let labelClass = "";
        if (isColumn) {
          labelClass = formClasses.SmallColumnLabel;
          labelStr = labelStr + ":";
        }
        if (
          editMode &&
          this.state[fieldName].validation &&
          this.state[fieldName].validation.required
        ) {
          labelClass = [labelClass, formClasses.Required].join(" ");
        }
        fieldLabel = <span className={labelClass}>{labelStr}</span>;
      }
    }

    return fieldLabel;
  }

  getMappedPropValue = (fieldName) => {
    //Use dbField for field object when there is a difference between the database column name and the UI name
    //Use dbGroup for field object when the column is in a sub group
    //Handle db key field differently - store in "dbKey" instead of a table specific name

    let value = "";

    if (this.props.dbData) {
      const field = this.state[fieldName];
      // if (doLog()) console.log("[Form][getMappedPropValue] field:", field);
      if (field != null) {
        let dbField = fieldName;
        let dbGroup = null;
        if (field.dbField && field.dbField != null) dbField = field.dbField;
        if (field.dbGroup && field.dbGroup != null) dbGroup = field.dbGroup;
        // if (doLog()) console.log("[Form][getMappedPropValue] dbField:", dbField);
        if (field.key) {
          value = notNull(this.props.dbKey);
          // value = notNull(this.props.customerNumber);
        } else {
          if (dbGroup != null)
            value = notNull(this.props.dbData[dbGroup][dbField]);
          else value = notNull(this.props.dbData[dbField]);
          // value = notNull(this.props.customerData[dbField]);
        }
      }
      // if (doLog()) console.log("[Form][getMappedPropValue] value:", value);
    }

    return notNull(value);
  };

  getFieldRequiredFoundInSection(fieldName, sectionName) {
    let found = false;
    let incidentType = "SAMPLETYPE";
    if (hasValue(this.props.selectedIncidentTypeData)) {
      incidentType = this.props.selectedIncidentTypeData.INCIDENTTYPE;
    }
    if (doLog())
      console.log(
        "[Form] getFieldRequiredFoundInSection fieldName:" +
          fieldName +
          " sectionName:" +
          sectionName +
          " incidentType:" +
          incidentType
      );
    if (doLog())
      console.log(
        "[Form] getFieldRequiredFoundInSection requiredFieldList:",
        this.props.requiredFieldList
      );
    if (hasValue(this.props.requiredFieldList)) {
      const selectedRow = this.props.requiredFieldList.find(
        (option) =>
          option.data.INCIDENTTYPE === incidentType &&
          option.data.FIELDNAME === fieldName &&
          option.data.SECTIONNAME === sectionName
      );
      if (hasValue(selectedRow)) found = true;
    }

    return found;
  }

  getFieldRequiredStatus(fieldName, sectionName) {
    let required = false;
    let incidentType = "SAMPLETYPE";
    if (hasValue(this.props.selectedIncidentTypeData)) {
      incidentType = this.props.selectedIncidentTypeData.INCIDENTTYPE;
    }
    if (hasValue(this.props.requiredFieldList)) {
      const selectedRow = this.props.requiredFieldList.find(
        (option) =>
          option.data.INCIDENTTYPE === incidentType &&
          option.data.FIELDNAME === fieldName &&
          option.data.SECTIONNAME === sectionName
      );
      if (hasValue(selectedRow)) {
        required = selectedRow.data.REQUIRE === "Y";
      } else {
        if (doLog())
          console.log(
            "[Form][getFieldRequiredStatus] selectedRow not found. field:" +
              fieldName +
              " sectionName:" +
              sectionName
          );
      }
    }
    if (doLog())
      console.log("[Form][getFieldRequiredStatus] fieldName:", fieldName);
    if (doLog())
      console.log("[Form][getFieldRequiredStatus] incidentType:", incidentType);
    if (doLog())
      console.log("[Form][getFieldRequiredStatus] sectionName:", sectionName);
    if (doLog())
      console.log("[Form][getFieldRequiredStatus] required:", required);
    return required;
  }

  handleCheckBoxChange = (fieldName) => (event) => {
    if (doLog()) console.log("[handleCheckBoxChange] fieldName:", fieldName);
    if (doLog())
      console.log("[handleCheckBoxChange] checked:", event.target.checked);
    if (doLog())
      console.log(
        "[handleCheckBoxChange] checkedValue:",
        this.state[fieldName].checkedValue
      );
    if (doLog())
      console.log(
        "[handleCheckBoxChange] uncheckedValue:",
        this.state[fieldName].uncheckedValue
      );
    let enterAllowed = this.state[fieldName].enterOnAddOnly ? false : true;
    if ((this.state.editMode && enterAllowed) || this.state.addMode) {
      if (event.target.checked) {
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: this.state[fieldName].checkedValue,
          }),
        });
        this.updateAttachmentArray(
          fieldName,
          this.state[fieldName].checkedValue
        );
        this.updateSharedIncidentDetails(
          fieldName,
          this.state[fieldName].checkedValue
        );
        this.updatePersonArray(fieldName, this.state[fieldName].checkedValue);
        this.updatePropertyArray(fieldName, this.state[fieldName].checkedValue);
        this.updateVehicleArray(fieldName, this.state[fieldName].checkedValue);
        this.updateCustomTextArray(
          fieldName,
          this.state[fieldName].checkedValue
        );
        this.updateRequiredFieldArray(
          fieldName,
          this.state[fieldName].checkedValue
        );
      } else {
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: this.state[fieldName].uncheckedValue,
          }),
        });
        this.updateAttachmentArray(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
        this.updateSharedIncidentDetails(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
        this.updatePersonArray(fieldName, this.state[fieldName].uncheckedValue);
        this.updatePropertyArray(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
        this.updateVehicleArray(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
        this.updateCustomTextArray(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
        this.updateRequiredFieldArray(
          fieldName,
          this.state[fieldName].uncheckedValue
        );
      }
    }
    if (fieldName === "NameType" && this.state.sectionName === "Person") {
      this.checkIfBusiness();
    }
  };

  handleDateChange = (fieldName) => (date) => {
    if (doLog()) console.log("[Form][handleDateChange] fieldName:", fieldName);
    if (doLog()) console.log("[Form][handleDateChange] date:", date);
    if (date) {
      const dateStr = moment(date).format("MM/DD/YYYY");
      if (doLog()) console.log("[Form][handleDateChange] dateStr:", dateStr);
      if (this.state.mappedTextPropFields.indexOf(fieldName) !== -1) {
        this.updateFieldValueState(fieldName, dateStr);
        this.updateAttachmentArray(fieldName, dateStr);
        this.updateSharedIncidentDetails(fieldName, dateStr);
        this.updatePersonArray(fieldName, dateStr);
        this.updatePropertyArray(fieldName, dateStr);
        this.updateVehicleArray(fieldName, dateStr);
        this.updateCustomTextArray(fieldName, dateStr);
        this.updateRequiredFieldArray(fieldName, dateStr);
      }
    }
  };

  handleDateTimeChange = (fieldName) => (date) => {
    if (doLog())
      console.log("[Form][handleDateTimeChange] fieldName:", fieldName);
    if (doLog()) console.log("[Form][handleDateTimeChange] date:", date);
    if (date) {
      const dateStr = moment(date).format("MM/DD/YYYY hh:mm A");
      if (doLog())
        console.log("[Form][handleDateTimeChange] dateStr:", dateStr);
      if (this.state.mappedTextPropFields.indexOf(fieldName) !== -1) {
        this.updateFieldValueState(fieldName, dateStr);
        this.updateAttachmentArray(fieldName, dateStr);
        this.updateSharedIncidentDetails(fieldName, dateStr);
        this.updatePersonArray(fieldName, dateStr);
        this.updatePropertyArray(fieldName, dateStr);
        this.updateVehicleArray(fieldName, dateStr);
        this.updateCustomTextArray(fieldName, dateStr);
        this.updateRequiredFieldArray(fieldName, dateStr);
      }
    }
  };

  handleGridRowClick = (fieldName) => (param, event) => {
    if (doLog()) console.log("[Form] handleGridRowClick fieldName:", fieldName);
    if (doLog()) console.log("[Form] handleGridRowClick param:", param);
    if (doLog()) console.log("[Form] handleGridRowClick event:", event);
  };

  handleGridCheckBoxClick = (fieldName) => (newSelectionModel) => {
    if (doLog())
      console.log("[Form] handleGridCheckBoxClick fieldName:", fieldName);
    if (doLog())
      console.log(
        "[Form] handleGridCheckBoxClick newSelectionModel:",
        newSelectionModel
      );
  };

  handleGridSearchChange = (fieldName, gridFieldName) => (event) => {
    if (doLog())
      console.log("[Form] handleGridSearchChange  fieldName:", fieldName);
    if (doLog())
      console.log(
        "[Form] handleGridSearchChange  gridFieldName:",
        gridFieldName
      );
    const value = event.target.value;
    if (doLog()) console.log("[Form] handleGridSearchChange  value:", value);
    this.setState({
      [fieldName]: updateObject(this.state[[fieldName]], {
        value: value,
        searchText: value,
      }),
      [gridFieldName]: updateObject(this.state[[gridFieldName]], {
        value: value,
        searchText: value,
      }),
    });
    this.handleGridSearchRequest(gridFieldName, value);
  };

  handleGridSearchClick = (fieldName, gridFieldName) => (event) => {
    if (doLog())
      console.log(
        "[Form] handleGridSearchClick fieldName:" +
          fieldName +
          " gridFieldName:" +
          gridFieldName
      );
    this.setState({
      [fieldName]: updateObject(this.state[fieldName], {
        value: "",
        searchText: "",
        gridRows: this.state[fieldName].gridDefaultRows,
      }),
      [gridFieldName]: updateObject(this.state[gridFieldName], {
        searchText: "",
        gridRows: this.state[gridFieldName].gridDefaultRows,
      }),
    });
  };

  handleGridSearchRequest = (fieldName, searchValue) => {
    if (doLog())
      console.log(
        "[Form] handleGridSearchRequest fieldName:" +
          fieldName +
          " searchValue:" +
          searchValue
      );
    const searchRegex = new RegExp(this.escapeRegExp(searchValue), "i");
    const filteredRows = this.state[fieldName].gridDefaultRows.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
    if (doLog())
      console.log("[Form] handleGridSearchRequest searchValue:", searchValue);
    if (doLog())
      console.log("[Form] handleGridSearchRequest searchRegex:", searchRegex);
    if (doLog())
      console.log("[Form] handleGridSearchRequest filteredRows:", filteredRows);
    this.setState({
      [fieldName]: updateObject(this.state[[fieldName]], {
        gridRows: filteredRows,
        searchText: searchValue,
      }),
    });
  };

  // handleKeyPress = (target) => {
  // if (doLog()) console.log("[Form][handleKeyPress] new key:", target.key);
  // if (target.key === "Enter") {
  //   if (doLog()) console.log("Enter pressed");
  //   this.handleSearchButton();
  // }
  // };

  handleRadioGroupChange = (fieldName) => (event) => {
    const statusSelected = event.target.value;

    let enterAllowed = this.state[fieldName].enterOnAddOnly ? false : true;
    if ((this.state.editMode && enterAllowed) || this.state.addMode) {
      if (statusSelected.value === -1) {
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], { value: "" }),
        });
        this.updateAttachmentArray(fieldName, "");
        this.updateSharedIncidentDetails(fieldName, "");
        this.updatePersonArray(fieldName, "");
        this.updatePropertyArray(fieldName, "");
        this.updateVehicleArray(fieldName, "");
        this.updateCustomTextArray(fieldName, "");
        this.updateRequiredFieldArray(fieldName, "");
      } else {
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: statusSelected,
          }),
        });
        this.updateAttachmentArray(fieldName, statusSelected);
        this.updateSharedIncidentDetails(fieldName, statusSelected);
        this.updatePersonArray(fieldName, statusSelected);
        this.updatePropertyArray(fieldName, statusSelected);
        this.updateVehicleArray(fieldName, statusSelected);
        this.updateCustomTextArray(fieldName, statusSelected);
        this.updateRequiredFieldArray(fieldName, statusSelected);
      }
    }

    if (doLog())
      console.log(`[handleRadioGroupChange] statusSelected:`, statusSelected);
  };

  handleSelectChange = (event, fieldName, listName) => {
    if (doLog()) console.log("[handleSelectChange] event", event);
    if (doLog()) console.log("[handleSelectChange] listName", listName);
    if (doLog()) console.log("[handleSelectChange] fieldName", fieldName);
    if (event && event !== null) {
      const eventValue = event.target.value;
      // const eventValue = event.value; //Use with react-dropdown-select
      if (!eventValue || eventValue === -1) {
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: "",
            labelValue: null,
          }),
          // [valueFieldName]: null,
        });
        this.updateAttachmentArray(fieldName, null);
        this.updateSharedIncidentDetails(fieldName, null);
        this.updatePersonArray(fieldName, "", null);
        this.updatePropertyArray(fieldName, "", null);
        this.updateVehicleArray(fieldName, "", null);
        this.updateCustomTextArray(fieldName, null);
        this.updateRequiredFieldArray(fieldName, null);
      } else {
        if (doLog())
          console.log(
            "[handleSelectChange] before find eventValue:",
            eventValue
          );
        if (hasValue(listName)) {
          const obj = this.props[listName].find(
            (option) => option.value === eventValue
          );
          if (doLog()) console.log("[handleSelectChange] obj", obj);
          this.setState({
            [fieldName]: updateObject(this.state[fieldName], {
              value: eventValue,
              labelValue: obj.label,
            }),
            // [valueFieldName]: obj.label,
          });
          this.updateAttachmentArray(fieldName, eventValue, obj.label);
          this.updateSharedIncidentDetails(fieldName, obj.label);
          this.updatePersonArray(fieldName, eventValue, obj.label);
          this.updatePropertyArray(fieldName, eventValue, obj.label);
          this.updateVehicleArray(fieldName, eventValue, obj.label);
          this.updateCustomTextArray(fieldName, eventValue, obj.label);
          this.updateRequiredFieldArray(fieldName, eventValue, obj.label);
        } else {
          this.setState({
            [fieldName]: updateObject(this.state[fieldName], {
              value: eventValue,
            }),
          });
        }
      }
      if (doLog()) console.log(`[handleSelectChange] eventValue:`, eventValue);
    }
  };

  handleTextChange = (fieldName) => (event) => {
    // if (doLog())
    //   console.log(
    //     "[Form][handleTextChange] sectionName:",
    //     this.state.sectionName
    //   );
    if (doLog()) console.log("[Form][handleTextChange] fieldName:", fieldName);
    // if (doLog()) console.log("[Form][handleTextChange] event:", event);
    if (doLog())
      console.log("[Form][handleTextChange] new value:", event.target.value);
    // if (doLog()) console.log("[Form][handleTextChange] editMode:", this.state.editMode);
    let enterAllowed = this.state[fieldName].enterOnAddOnly ? false : true;
    let value = event.target.value;
    if (this.state[fieldName].upperOnly) {
      value = value.toUpperCase();
    }
    let maxSize = 0;
    if (hasValue(this.state[fieldName].maxSize))
      maxSize = this.state[fieldName].maxSize;
    if (maxSize > 0 && value.length > maxSize) {
      value = value.substring(0, maxSize);
    }
    // if (doLog())
    //   console.log(
    //     "[Form][handleTextChange] enterAllowed:" +
    //       enterAllowed +
    //       " addMode:" +
    //       this.state.addMode
    //   );
    if ((this.state.editMode && enterAllowed) || this.state.addMode) {
      const index = this.state.mappedTextPropFields.indexOf(fieldName);
      if (doLog()) console.log("[Form][handleTextChange] field index:", index);
      if (index !== -1) {
        this.updateFieldValueState(fieldName, value);
        if (this.state.sectionName === "Attachment")
          this.updateAttachmentArray(fieldName, value);
        if (this.state.sectionName === "CrimeSubmission")
          this.updateSharedIncidentDetails(fieldName, value);
        if (this.state.sectionName === "Person")
          this.updatePersonArray(fieldName, value);
        if (this.state.sectionName === "Property")
          this.updatePropertyArray(fieldName, value);
        if (this.state.sectionName === "Vehicle")
          this.updateVehicleArray(fieldName, value);
        if (this.state.sectionName === "ManageCustomText")
          this.updateCustomTextArray(fieldName, value);
        if (
          this.state.sectionName === "ManageIncidentType" ||
          this.state.sectionName === "ManageRequireField"
        )
          this.updateRequiredFieldArray(fieldName, value);
        if (doLog())
          console.log("[Form][handleTextChange] after field display");
      }
    }
  };

  isFieldValueSet(fieldName) {
    let isSet = false;
    if (
      this.state[fieldName] &&
      this.state[fieldName].value &&
      this.state[fieldName].value.length > 0
    ) {
      isSet = true;
    }

    return isSet;
  }

  putMappedPropValue = (fieldName, value) => {
    //Use dbField for field object when there is a difference between the database column name and the UI name
    //Use dbGroup for field object when the column is in a sub group
    //Handle db key field differently - store in "dbKey" instead of a table specific name

    const field = this.state[fieldName];
    if (field) {
      let dbField = fieldName;
      let dbGroup = null;
      if (field.dbField && field.dbField != null) dbField = field.dbField;
      if (field.dbGroup && field.dbGroup != null) dbGroup = field.dbGroup;
      if (field.key) {
        this.props.dbKey = value;
      } else {
        if (dbGroup != null) this.props.dbData[dbGroup][dbField] = value;
        else this.props.dbData[dbField] = value;
      }
    }
  };

  updateAttachmentArray(fieldName, newValue, newLabelValue) {
    if (doLog())
      console.log("[Form]updateAttachmentArray item:", this.props.item);
    // if (doLog()) console.log("[Form]updateAttachmentArray item available:", (this.props.item && this.props.item !== null));
    if (this.props.item && this.props.item !== null) {
      // if (doLog()) console.log("[Form]updateAttachmentArray instance available:", (this.props.item.attachmentInstance >= 0));
      if (this.props.item.attachmentInstance >= 0) {
        const newArray = [];
        // if (doLog()) console.log("[Form]updateAttachmentArray array length:", this.props.attachmentArray.length);
        if (doLog())
          console.log(
            "[Form]updateAttachmentArray fieldName:" +
              fieldName +
              " newValue:" +
              newValue +
              " newLabelValue:" +
              newLabelValue
          );
        for (let i = 0; i < this.props.attachmentArray.length; i++) {
          //if (doLog()) console.log("[Form]updateAttachmentArray i:", i);
          if (i === getNumber(this.props.item.attachmentInstance)) {
            let attachmentFields = {
              attachmentTitle: this.state.attachmentTitle,
              attachmentFileName: this.state.attachmentFileName,
              attachmentSize: this.state.attachmentSize,
              attachmentFileType: this.state.attachmentFileType,
              selectedFile: this.state.selectedFile,
              previewUrl: this.state.previewUrl,
              id: this.state.id,
              deleted: this.state.deleted,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              attachmentFields = {
                attachmentTitle: this.state.attachmentTitle,
                attachmentFileName: this.state.attachmentFileName,
                attachmentSize: this.state.attachmentSize,
                attachmentFileType: this.state.attachmentFileType,
                selectedFile: this.state.selectedFile,
                previewUrl: this.state.previewUrl,
                id: this.state.id,
                deleted: this.state.deleted,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push({
              attachmentInstance: getNumber(this.props.item.attachmentInstance),
              attachmentFields: attachmentFields,
            });
          } else {
            newArray.push(this.props.attachmentArray[i]);
          }
        }
        if (doLog())
          console.log("[Form]updateAttachmentArray newArray:", newArray);
        this.props.onSetAttachmentArray(newArray);
      }
    }
  }

  updateCustomTextArray(fieldName, newValue, newLabelValue) {
    // if (doLog()) console.log("[Form]updateCustomTextArray item:", this.props.item);
    // if (doLog()) console.log("[Form]updateCustomTextArray item available:", (this.props.item && this.props.item !== null));
    if (this.props.item && this.props.item !== null) {
      const index = this.state.customTextIndex;
      if (index >= 0) {
        const newArray = [];
        if (doLog())
          console.log(
            "[Form]updateCustomTextArray fieldName:" +
              fieldName +
              " newValue:" +
              newValue +
              " newLabelValue:" +
              newLabelValue
          );
        if (doLog()) console.log("[Form]updateCustomTextArray index:", index);

        for (let i = 0; i < this.props.customTextArray.length; i++) {
          //if (doLog()) console.log("[Form]updateCustomTextArray i:", i);
          if (i === index) {
            let fields = {
              AGENCYCODE: this.state.AGENCYCODE,
              TEXTLOCATION: this.state.TEXTLOCATION,
              CUSTOMTEXT: this.state.CUSTOMTEXT,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              fields = {
                AGENCYCODE: this.state.AGENCYCODE,
                TEXTLOCATION: this.state.TEXTLOCATION,
                CUSTOMTEXT: this.state.CUSTOMTEXT,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push(fields);
          } else {
            newArray.push(this.props.customTextArray[i]);
          }
        }
        if (doLog())
          console.log("[Form]updateCustomTextArray newArray:", newArray);
        this.props.onSetCustomTextArray(newArray);
      }
    }
  }

  updateFieldValueState(fieldName, newValue) {
    if (doLog())
      console.log("[Form][updateFieldValueState] fieldName:", fieldName);
    if (doLog())
      console.log("[Form][updateFieldValueState] newValue:", newValue);
    // if (!this.state.fieldUpdate || this.state.fieldName !== fieldName) {
    this.setState({
      [fieldName]: updateObject(this.state[fieldName], {
        value: newValue,
        valid: checkValidity(newValue, this.state[fieldName].validation),
      }),
      fieldUpdate: true,
    });
  }

  updatePersonArray(fieldName, newValue, newLabelValue) {
    // if (doLog()) console.log("[Form]updatePersonArray item:", this.props.item);
    // if (doLog()) console.log("[Form]updatePersonArray item available:", (this.props.item && this.props.item !== null));
    if (this.props.item && this.props.item !== null) {
      // if (doLog()) console.log("[Form]updatePersonArray instance available:", (this.props.item.personInstance >= 0));
      if (this.props.item.personInstance >= 0) {
        const newArray = [];
        // if (doLog()) console.log("[Form]updatePersonArray array length:", this.props.personArray.length);
        if (doLog())
          console.log(
            "[Form]updatePerspmArray fieldName:" +
              fieldName +
              " newValue:" +
              newValue +
              " newLabelValue:" +
              newLabelValue
          );
        for (let i = 0; i < this.props.personArray.length; i++) {
          //if (doLog()) console.log("[Form]updatePersonArray i:", i);
          let idValue = -1;
          if (hasValue(this.state.id)) idValue = this.state.id;
          if (i === getNumber(this.props.item.personInstance)) {
            let personFields = {
              id: idValue,
              personInvolvement: this.state.personInvolvement,
              firstName: this.state.firstName,
              middleName: this.state.middleName,
              lastName: this.state.lastName,
              email: this.state.email,
              homePhone: this.state.homePhone,
              cellPhone: this.state.cellPhone,
              workPhone: this.state.workPhone,
              race: this.state.race,
              ethnicity: this.state.ethnicity,
              sex: this.state.sex,
              dob: this.state.dob,
              oln: this.state.oln,
              olnState: this.state.olnState,
              ssn: this.state.ssn,
              height: this.state.height,
              weight: this.state.weight,
              eyeColor: this.state.eyeColor,
              hairColor: this.state.hairColor,
              //
              homeStreetNumber: this.state.homeStreetNumber,
              homeStreetName: this.state.homeStreetName,
              homeApt: this.state.homeApt,
              homeCity: this.state.homeCity,
              homeState: this.state.homeState,
              homeZip: this.state.homeZip,
              //
              workBusinessName: this.state.workBusinessName,
              workStreetNumber: this.state.workStreetNumber,
              workStreetName: this.state.workStreetName,
              workApt: this.state.workApt,
              workCity: this.state.workCity,
              workState: this.state.workState,
              workZip: this.state.workZip,
              deleted: this.state.deleted,
              nameType: this.state.nameType,
              timsNameID: this.state.timsNameID,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              personFields = {
                id: idValue,
                personInvolvement: this.state.personInvolvement,
                firstName: this.state.firstName,
                middleName: this.state.middleName,
                lastName: this.state.lastName,
                email: this.state.email,
                homePhone: this.state.homePhone,
                cellPhone: this.state.cellPhone,
                workPhone: this.state.workPhone,
                race: this.state.race,
                ethnicity: this.state.ethnicity,
                sex: this.state.sex,
                dob: this.state.dob,
                oln: this.state.oln,
                olnState: this.state.olnState,
                ssn: this.state.ssn,
                height: this.state.height,
                weight: this.state.weight,
                eyeColor: this.state.eyeColor,
                hairColor: this.state.hairColor,
                //
                homeStreetNumber: this.state.homeStreetNumber,
                homeStreetName: this.state.homeStreetName,
                homeApt: this.state.homeApt,
                homeCity: this.state.homeCity,
                homeState: this.state.homeState,
                homeZip: this.state.homeZip,
                //
                workBusinessName: this.state.workBusinessName,
                workStreetNumber: this.state.workStreetNumber,
                workStreetName: this.state.workStreetName,
                workApt: this.state.workApt,
                workCity: this.state.workCity,
                workState: this.state.workState,
                workZip: this.state.workZip,
                deleted: this.state.deleted,
                nameType: this.state.nameType,
                timsNameID: this.state.timsNameID,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push({
              personInstance: getNumber(this.props.item.personInstance),
              personFields: personFields,
            });
          } else {
            newArray.push(this.props.personArray[i]);
          }
        }
        if (doLog()) console.log("[Form]updatePersonArray newArray:", newArray);
        this.props.onSetPersonArray(newArray);
      }
    }
  }

  updatePropertyArray(fieldName, newValue, newLabelValue) {
    // if (doLog()) console.log("[Form]updatePropertyArray item:", this.props.item);
    // if (doLog()) console.log("[Form]updatePropertyArray item available:", (this.props.item && this.props.item !== null));
    if (this.props.item && this.props.item !== null) {
      // if (doLog()) console.log("[Form]updatePropertyArray instance available:", (this.props.item.propertyInstance >= 0));
      if (this.props.item.propertyInstance >= 0) {
        const newArray = [];
        // if (doLog()) console.log("[Form]updatePropertyArray array length:", this.props.propertyArray.length);
        if (doLog())
          console.log(
            "[Form]updatePropertyArray fieldName:" +
              fieldName +
              " newValue:" +
              newValue +
              " newLabelValue:" +
              newLabelValue
          );
        for (let i = 0; i < this.props.propertyArray.length; i++) {
          //if (doLog()) console.log("[Form]updatePropertyArray i:", i);
          let idValue = -1;
          if (hasValue(this.state.id)) idValue = this.state.id;
          if (i === getNumber(this.props.item.propertyInstance)) {
            let propertyFields = {
              id: idValue,
              propertyDescription: this.state.propertyDescription,
              propertyType: this.state.propertyType,
              propertyColor: this.state.propertyColor,
              propertyMake: this.state.propertyMake,
              propertyModel: this.state.propertyModel,
              propertySerialNo: this.state.propertySerialNo,
              propertyQuantity: this.state.propertyQuantity,
              propertyMarketValue: this.state.propertyMarketValue,
              propertyDamagedValue: this.state.propertyDamagedValue,
              deleted: this.state.deleted,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              propertyFields = {
                id: idValue,
                propertyDescription: this.state.propertyDescription,
                propertyType: this.state.propertyType,
                propertyColor: this.state.propertyColor,
                propertyMake: this.state.propertyMake,
                propertyModel: this.state.propertyModel,
                propertySerialNo: this.state.propertySerialNo,
                propertyQuantity: this.state.propertyQuantity,
                propertyMarketValue: this.state.propertyMarketValue,
                propertyDamagedValue: this.state.propertyDamagedValue,
                deleted: this.state.deleted,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push({
              propertyInstance: getNumber(this.props.item.propertyInstance),
              propertyFields: propertyFields,
            });
          } else {
            newArray.push(this.props.propertyArray[i]);
          }
        }
        if (doLog())
          console.log("[Form]updatePropertyArray newArray:", newArray);
        this.props.onSetPropertyArray(newArray);
      }
    }
  }

  updatePropsWithChanges(dbKey, dbData) {
    if (doLog()) console.log("[Form][updatePropsWithChanges]");
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      if (doLog()) console.log("updatePropsWithChanges text field:", field);
      if (doLog()) console.log("updatePropsWithChanges fieldName:", fieldName);
      if (this.checkFieldForChange(fieldName, false)) {
        this.putMappedPropValue(
          fieldName,
          this.state[fieldName].value,
          dbKey,
          dbData
        );
      }
    }
    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      if (doLog()) console.log("updatePropsWithChanges select field:", field);
      if (doLog()) console.log("updatePropsWithChanges fieldName:", fieldName);
      if (this.checkFieldForChange(fieldName, true)) {
        this.putMappedPropValue(
          fieldName,
          // this.state[fieldName],
          this.state[fieldName].value,
          dbKey,
          dbData
        );
      }
    }
  }

  updateRequiredFieldArray(fieldName, newValue, newLabelValue) {
    if (doLog())
      console.log("[Form]updateRequiredFieldArray item:", this.props.item);
    if (doLog())
      console.log(
        "[Form]updateRequiredFieldArray item available:",
        this.props.item && this.props.item !== null
      );
    if (this.props.item && this.props.item !== null) {
      const index = this.state.requiredFieldIndex;
      if (index >= 0) {
        const newArray = [];
        if (doLog())
          console.log(
            "[Form]updateRequiredFieldArray fieldName:" +
              fieldName +
              " newValue:" +
              newValue +
              " newLabelValue:" +
              newLabelValue
          );
        if (doLog())
          console.log("[Form]updateRequiredFieldArray index:", index);

        for (let i = 0; i < this.props.requiredFieldArray.length; i++) {
          //if (doLog()) console.log("[Form]updateRequiredFieldArray i:", i);
          if (i === index) {
            let fields = {
              ORI: this.state.ORI,
              INCIDENTTYPE: this.state.INCIDENTTYPE,
              SECTIONNAME: this.state.SECTIONNAME,
              FIELDNAME: this.state.FIELDNAME,
              REQUIRE: this.state.REQUIRE,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              fields = {
                ORI: this.state.ORI,
                INCIDENTTYPE: this.state.INCIDENTTYPE,
                SECTIONNAME: this.state.SECTIONNAME,
                FIELDNAME: this.state.FIELDNAME,
                REQUIRE: this.state.REQUIRE,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push(fields);
          } else {
            newArray.push(this.props.requiredFieldArray[i]);
          }
        }
        if (doLog())
          console.log("[Form]updateRequiredFieldArray newArray:", newArray);
        this.props.onSetRequiredFieldArray(newArray);
      }
    }
  }

  updateSharedIncidentDetails(fieldName, newValue, newLabelValue) {
    if (this.state.sectionName === "CrimeSubmission") {
      if (doLog())
        console.log(
          "[Form]updateSharedIncidentDetails sharedIncidentDetails:",
          this.props.sharedIncidentDetails
        );
      // if (
      //   this.props.sharedIncidentDetails &&
      //   this.props.sharedIncidentDetails !== null
      // ) {
      if (doLog())
        console.log(
          "[Form]updateSharedIncidentDetails fieldName:" +
            fieldName +
            " newValue:" +
            newValue +
            " newLabelValue:" +
            newLabelValue
        );
      let curIncidentNumber = null;
      let curIncidentFromDate = null;
      let curIncidentToDate = null;
      let curIncidentDesc = null;
      let curIncidentBusinessName = null;
      let curIncidentStreetNumber = null;
      let curIncidentStreetName = null;
      let curIncidentApt = null;
      let curIncidentCity = null;
      let curIncidentState = null;
      let curIncidentZip = null;
      let curTimsAddressNumber = null;
      //
      let curFirstName = null;
      let curMiddleName = null;
      let curLastName = null;
      let curEmail = null;
      let curHomePhone = null;
      let curCellPhone = null;
      let curWorkPhone = null;
      let curRace = null;
      let curSex = null;
      let curEthnicity = null;
      let curDob = null;
      let curOln = null;
      let curOlnState = null;
      let curSsn = null;
      let curHeight = null;
      let curWeight = null;
      let curEyeColor = null;
      let curHairColor = null;
      //
      let curUserBusinessName = null;
      let curUserStreetNumber = null;
      let curUserStreetName = null;
      let curUserApt = null;
      let curUserCity = null;
      let curUserState = null;
      let curUserZip = null;
      //
      let curTowCompanyName = null;
      let curTowStreetNumber = null;
      let curTowStreetName = null;
      let curTowApt = null;
      let curTowCity = null;
      let curTowState = null;
      let curTowZip = null;
      let curId = null;
      let curStatus = null;
      //
      if (
        hasValue(this.state.incidentNumber) &&
        this.state.incidentNumber.state
      )
        curIncidentNumber = this.state.incidentNumber.state;
      if (
        hasValue(this.state.incidentFromDate) &&
        this.state.incidentFromDate.state
      )
        curIncidentFromDate = this.state.incidentFromDate.state;
      if (
        hasValue(this.state.incidentToDate) &&
        this.state.incidentToDate.state
      )
        curIncidentToDate = this.state.incidentDesc.state;
      if (hasValue(this.state.incidentDesc) && this.state.incidentDesc.state)
        curIncidentDesc = this.state.incidentDesc.state;
      if (
        hasValue(this.state.incidentBusinessName) &&
        this.state.incidentBusinessName.state
      )
        curIncidentBusinessName = this.state.incidentBusinessName.state;
      if (
        hasValue(this.state.incidentStreetNumber) &&
        this.state.incidentStreetNumber.state
      )
        curIncidentStreetNumber = this.state.incidentStreetNumber.state;
      if (
        hasValue(this.state.incidentStreetName) &&
        this.state.incidentStreetName.state
      )
        curIncidentStreetName = this.state.incidentStreetName.state;
      if (hasValue(this.state.incidentApt) && this.state.incidentApt.state)
        curIncidentApt = this.state.incidentApt.state;
      if (hasValue(this.state.incidentCity) && this.state.incidentCity.state)
        curIncidentCity = this.state.incidentCity.state;
      if (hasValue(this.state.incidentState) && this.state.incidentState.state)
        curIncidentState = this.state.incidentState.state;
      if (hasValue(this.state.incidentZip) && this.state.incidentZip.state)
        curIncidentZip = this.state.incidentZip.state;
      if (
        hasValue(this.state.timsAddressNumber) &&
        this.state.timsAddressNumber.state
      )
        curTimsAddressNumber = this.state.timsAddressNumber.state;
      //
      if (hasValue(this.state.firstName) && this.state.firstName.state)
        curFirstName = this.state.firstName.state;
      if (hasValue(this.state.middleName) && this.state.middleName.state)
        curMiddleName = this.state.middleName.state;
      if (hasValue(this.state.lastName) && this.state.lastName.state)
        curLastName = this.state.lastName.state;
      if (hasValue(this.state.email) && this.state.email.state)
        curEmail = this.state.email.state;
      if (hasValue(this.state.homePhone) && this.state.homePhone.state)
        curHomePhone = this.state.homePhone.state;
      if (hasValue(this.state.cellPhone) && this.state.cellPhone.state)
        curCellPhone = this.state.cellPhone.state;
      if (hasValue(this.state.workPhone) && this.state.workPhone.state)
        curWorkPhone = this.state.workPhone.state;
      if (hasValue(this.state.race) && this.state.race.state)
        curRace = this.state.race.state;
      if (hasValue(this.state.sex) && this.state.sex.state)
        curSex = this.state.sex.state;
      if (hasValue(this.state.ethnicity) && this.state.ethnicity.state)
        curEthnicity = this.state.ethnicity.state;
      if (hasValue(this.state.dob) && this.state.dob.state)
        curDob = this.state.dob.state;
      if (hasValue(this.state.oln) && this.state.oln.state)
        curOln = this.state.oln.state;
      if (hasValue(this.state.olnState) && this.state.olnState.state)
        curOlnState = this.state.olnState.state;
      if (hasValue(this.state.ssn) && this.state.ssn.state)
        curSsn = this.state.ssn.state;
      if (hasValue(this.state.height) && this.state.height.state)
        curHeight = this.state.height.state;
      if (hasValue(this.state.weight) && this.state.weight.state)
        curWeight = this.state.weight.state;
      if (hasValue(this.state.eyeColor) && this.state.eyeColor.state)
        curEyeColor = this.state.eyeColor.state;
      if (hasValue(this.state.hairColor) && this.state.hairColor.state)
        curHairColor = this.state.hairColor.state;
      //
      if (
        hasValue(this.state.userBusinessName) &&
        this.state.userBusinessName.state
      )
        curUserBusinessName = this.state.userBusinessName.state;
      if (
        hasValue(this.state.userStreetNumber) &&
        this.state.userStreetNumber.state
      )
        curUserStreetNumber = this.state.incidentZip.state;
      if (
        hasValue(this.state.userStreetName) &&
        this.state.userStreetName.state
      )
        curUserStreetName = this.state.userStreetName.state;
      if (hasValue(this.state.userApt) && this.state.userApt.state)
        curUserApt = this.state.userApt.state;
      if (hasValue(this.state.userCity) && this.state.userCity.state)
        curUserCity = this.state.userCity.state;
      if (hasValue(this.state.userState) && this.state.userState.state)
        curUserState = this.state.userState.state;
      if (hasValue(this.state.userZip) && this.state.userZip.state)
        curUserZip = this.state.userZip.state;
      //
      if (
        hasValue(this.state.towCompanyName) &&
        this.state.towCompanyName.state
      )
        curTowCompanyName = this.state.towCompanyName.state;
      if (
        hasValue(this.state.towStreetNumber) &&
        this.state.towStreetNumber.state
      )
        curTowStreetNumber = this.state.towStreetNumber.state;
      if (hasValue(this.state.towStreetName) && this.state.towStreetName.state)
        curTowStreetName = this.state.towStreetName.state;
      if (hasValue(this.state.towApt) && this.state.towApt.state)
        curTowApt = this.state.towApt.state;
      if (hasValue(this.state.towCity) && this.state.towCity.state)
        curTowCity = this.state.towCity.state;
      if (hasValue(this.state.towState) && this.state.towState.state)
        curTowState = this.state.towState.state;
      if (hasValue(this.state.towZip) && this.state.towZip.state)
        curTowZip = this.state.towZip.state;
      if (hasValue(this.state.id) && this.state.id.state)
        curId = this.state.id.state;
      if (hasValue(this.state.status) && this.state.status.state)
        curStatus = this.state.status.state;

      let sharedIncidentDetails = {
        incidentNumber: curIncidentNumber,
        incidentFromDate: curIncidentFromDate,
        incidentToDate: curIncidentToDate,
        incidentDesc: curIncidentDesc,
        //
        firstName: curFirstName,
        middleName: curMiddleName,
        lastName: curLastName,
        email: curEmail,
        homePhone: curHomePhone,
        cellPhone: curCellPhone,
        workPhone: curWorkPhone,
        race: curRace,
        sex: curSex,
        ethnicity: curEthnicity,
        dob: curDob,
        oln: curOln,
        olnState: curOlnState,
        ssn: curSsn,
        height: curHeight,
        weight: curWeight,
        eyeColor: curEyeColor,
        hairColor: curHairColor,
        //
        incidentBusinessName: curIncidentBusinessName,
        incidentStreetNumber: curIncidentStreetNumber,
        incidentStreetName: curIncidentStreetName,
        incidentApt: curIncidentApt,
        incidentCity: curIncidentCity,
        incidentState: curIncidentState,
        incidentZip: curIncidentZip,
        timsAddressNumber: curTimsAddressNumber,
        //
        userBusinessName: curUserBusinessName,
        userStreetNumber: curUserStreetNumber,
        userStreetName: curUserStreetName,
        userApt: curUserApt,
        userCity: curUserCity,
        userState: curUserState,
        userZip: curUserZip,
        //
        towCompanyName: curTowCompanyName,
        towStreetNumber: curTowStreetNumber,
        towStreetName: curTowStreetName,
        towApt: curTowApt,
        towCity: curTowCity,
        towState: curTowState,
        towZip: curTowZip,
        id: curId,
        status: curStatus,
        [fieldName]: this.state[fieldName].value,
      };

      if (doLog())
        console.log(
          "[Form]updateSharedIncidentDetails sharedIncidentDetails:",
          sharedIncidentDetails
        );
      this.props.onSetSharedIncidentDetails(sharedIncidentDetails);
    }
  }

  updateStateFromProps() {
    if (doLog()) console.log("[Form][updateStateFromProps]");
    if (doLog())
      console.log(
        "[Form][updateStateFromProps] mappedTextPropFields:",
        this.state.mappedTextPropFields
      );

    if (this.props.dbData && this.props.dbData !== null) {
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        // if (doLog()) console.log("updateStateFromProps field:",  fieldName);
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: this.getMappedPropValue(fieldName),
          }),
        });
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        const value = this.getMappedPropValue(fieldName);
        const valueLabel = lookupLabelFromList(
          this.props.designerList,
          notNull(value)
        );
        if (doLog())
          console.log(
            "[Form][updateStateFromProps] mapped select field:",
            fieldName
          );
        if (doLog())
          console.log(
            "[Form][updateStateFromProps] mapped select value:",
            value
          );
        if (doLog())
          console.log(
            "[Form][updateStateFromProps] mapped select valueLabel:",
            valueLabel
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: value,
          }),
          dfltSlsPerName: valueLabel,
        });
      }
    }
  }

  updateVehicleArray(fieldName, newValue, newLabelValue) {
    if (this.props.item && this.props.item !== null) {
      if (doLog())
        console.log(
          "[Form]updateVehicleArray fieldName:" + fieldName + " item:",
          this.props.item
        );
      if (this.props.item.vehicleInstance >= 0) {
        const newArray = [];
        // if (doLog()) console.log("[Form]updateVehicleArray fieldName:" + fieldName + " newValue:" + newValue + " newLabelValue:" + newLabelValue);
        // if (doLog()) console.log("[Form]updateVehicleArray fieldName:" + fieldName + " newValue:" + newValue);
        for (let i = 0; i < this.props.vehicleArray.length; i++) {
          //if (doLog()) console.log("[Form]updateVehicleArray i:", i);
          let idValue = -1;
          if (hasValue(this.state.id)) idValue = this.state.id;
          if (i === getNumber(this.props.item.vehicleInstance)) {
            let vehicleFields = {
              id: idValue,
              vehicleInvolvement: this.state.vehicleInvolvement,
              vehicleDescription: this.state.vehicleDescription,
              vehicleYear: this.state.vehicleYear,
              vehiclePlateTag: this.state.vehiclePlateTag,
              vehicleStateCode: this.state.vehicleStateCode,
              vehicleVIN: this.state.vehicleVIN,
              vehicleBodyStyle: this.state.vehicleBodyStyle,
              vehicleMake: this.state.vehicleMake,
              vehicleModel: this.state.vehicleModel,
              vehicleColor1: this.state.vehicleColor1,
              vehicleDamageValue: this.state.vehicleDamageValue,
              vehicleInsuranceCompany: this.state.vehicleInsuranceCompany,
              vehiclePolicyHolder: this.state.vehiclePolicyHolder,
              vehiclePolicyNumber: this.state.vehiclePolicyNumber,
              deleted: this.state.deleted,
              [fieldName]: updateObject(this.state[fieldName], {
                value: newValue,
              }),
            };

            if (newLabelValue) {
              vehicleFields = {
                id: idValue,
                vehicleInvolvement: this.state.vehicleInvolvement,
                vehicleDescription: this.state.vehicleDescription,
                vehicleYear: this.state.vehicleYear,
                vehiclePlateTag: this.state.vehiclePlateTag,
                vehicleStateCode: this.state.vehicleStateCode,
                vehicleVIN: this.state.vehicleVIN,
                vehicleBodyStyle: this.state.vehicleBodyStyle,
                vehicleMake: this.state.vehicleMake,
                vehicleModel: this.state.vehicleModel,
                vehicleColor1: this.state.vehicleColor1,
                vehicleDamageValue: this.state.vehicleDamageValue,
                vehicleInsuranceCompany: this.state.vehicleInsuranceCompany,
                vehiclePolicyHolder: this.state.vehiclePolicyHolder,
                vehiclePolicyNumber: this.state.vehiclePolicyNumber,
                deleted: this.state.deleted,
                [fieldName]: updateObject(this.state[fieldName], {
                  value: newValue,
                  labelValue: newLabelValue,
                }),
              };
            }

            newArray.push({
              vehicleInstance: getNumber(this.props.item.vehicleInstance),
              vehicleFields: vehicleFields,
            });
          } else {
            newArray.push(this.props.vehicleArray[i]);
          }
        }
        if (doLog())
          console.log("[Form]updateVehicleArray newArray:", newArray);
        this.props.onSetVehicleArray(newArray);
      }
    }
  }
}

export default Form;
// export default React.memo(Form, (prev, next) => {
//   const noChange =
//     prev.this.props.sharedIncidentDetails === next.this.props.sharedIncidentDetails;
//   return (
//     noChange
//   );
// });
